import {Injectable, isDevMode, signal} from '@angular/core';
import {getFromStorage} from '../../helpers/session-storage.helper';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {endpoints} from '../endpoints';
import {lastValueFrom} from 'rxjs';
import {LoginRoot} from '../../models/login.model';
import {deleteAllCookies} from '../../helpers/cookie.helper';

// sono le chiavi con cui vengono salvati i token
const TOKEN_KEY = 'auth-token';
const REFRESH_TOKEN_KEY = 'auth-refresh-token';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  /**
   * Service per gestire l'autenticazione dell'utente
   */

    // Un signal per sapere se l'utente è autenticato.
    // Controlla subito il sessionStorage!
  isAuthenticated = signal<boolean>(!!getFromStorage(TOKEN_KEY));

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  async login(username: string, password: string): Promise<void> {
    try {

      const url = endpoints.loginEndpoint;
      const body = {username, password};

      // 1. Fai la chiamata POST per il login
      const response = await lastValueFrom(this.http.post<LoginRoot>(url, body));

      // 2. Salva i token nel sessionStorage
      sessionStorage.setItem(TOKEN_KEY, response.token);
      sessionStorage.setItem(REFRESH_TOKEN_KEY, response.refresh);

      // 3. Aggiorna lo stato di autenticazione
      this.isAuthenticated.set(true);

      // La navigazione dopo l'accesso spetta a chi chiama: la pagina di login
      // sceglie fra la home e la pagina richiesta prima dell'accesso, e la
      // modale di primo accesso resta dove si trova.

    } catch (error) {
      // In caso di errore, pulisci tutto
      if (isDevMode()) console.error('Login failed', error);
      throw error; // Rilancia l'errore per farlo gestire al componente
    }
  }

  //TODO poi si aggancerà il servizio quando presente
  logout() {
    this.clearAllSessionData();
    this.router.navigate(['login']);
  }

  private clearAllSessionData() {
    this.isAuthenticated.set(false);
    localStorage.clear();
    sessionStorage.clear();
    deleteAllCookies();
  }
}
